<app-menu>
  <div class="desktop">
    <div class="header">
      <app-titulo text="Disciplinas"></app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Ver projetos"
          width="100%"
          icon="assets/images/graphics.svg"
          (click)="navigateVerProjetos()"
        ></app-botao>
        <app-botao
          type="primario"
          text="Cadastrar disciplina"
          width="100%"
          icon="assets/images/add.svg"
          (click)="navigateCadastrarArea()"
        ></app-botao>
      </div>
    </div>
    <div class="table-header">
      <h1 class="table-title">Listagem de disciplinas</h1>
      <div class="table-filters">
        <app-input
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          name="web-search"
          [(ngModel)]="pesquisaParams.TxPesquisa"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
      </div>
    </div>
    <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
    <app-paginacao
      [pages]="pesquisaParams.MaxPages"
      (selectedPage)="mudarPagina($event)"
    ></app-paginacao>
  </div>

  <div class="mobile">
    <app-titulo text="Disciplinas"></app-titulo>
    <div class="listagem">
      <div
        class="menu-mobile"
        (click)="expandirCardsMobile = !expandirCardsMobile"
      >
        <app-titulo class="title" text="Listagem de disciplinas"></app-titulo>
        <img
          class="expandir-icon"
          src="assets/images/arrow-down.svg"
          *ngIf="!expandirCardsMobile"
        />
        <img
          class="expandir-icon"
          src="assets/images/arrow-up.svg"
          *ngIf="expandirCardsMobile"
        />
      </div>
      <div class="mobile-filters">
        <app-input
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          name="mobile-serach"
          [(ngModel)]="pesquisaParams.TxPesquisa"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-botao
          type="primario"
          text="Ver projetos"
          width="100%"
          icon="assets/images/graphics.svg"
          *ngIf="expandirCardsMobile"
          (click)="navigateVerProjetos()"
        ></app-botao>
        <app-botao
          type="primario"
          text="Cadastrar disciplina"
          width="100%"
          icon="assets/images/add.svg"
          (click)="navigateCadastrarArea()"
        ></app-botao>
      </div>
      <app-card-mobile
        [data]="tableData"
        [rows]="rowsMobile"
        [expand]="expandirCardsMobile"
      ></app-card-mobile>
      <app-paginacao
        [pages]="pesquisaParams.MaxPages"
        (selectedPage)="mudarPagina($event)"
      ></app-paginacao>
    </div>
  </div>
</app-menu>

<app-loader *ngIf="loader" />
